import { isMobile } from './isMobile';

export function mousePositionToIconColumnRow(element, mouseEvent) {
  const finalYPositions = isMobile() ? [0, 76, 152, 228, 304] : [0, 127.5, 255, 382.5];
  const finalXPositions = isMobile() ? [0, 104, 208, 312, 416] : [0, 174, 348, 522, 696];
  const scale = isMobile() ? Math.min(window.innerWidth / 540, window.innerHeight / 960) : 1;
  const globalPoint = mouseEvent.data.global;
  const { tx, ty } = element.worldTransform;
  const containerX = globalPoint.x / scale - tx;
  const containerY = globalPoint.y / scale - ty;
  const iconHalfWidth = (isMobile() ? 100 : 170) / scale / 2;
  const iconHalfHeight = (isMobile() ? 76 : 127.5) / scale / 2;
  const column = finalXPositions.findIndex(
    (columnCenter) =>
      containerX >= columnCenter - iconHalfWidth && containerX <= columnCenter + iconHalfWidth
  );
  const row = finalYPositions.findIndex(
    (rowCenter) =>
      containerY >= rowCenter - iconHalfHeight && containerY <= rowCenter + iconHalfHeight
  );
  if (column > -1 && row > -1) {
    return { column, row };
  }
  return null;
}
